import { Modal } from "antd";
// import "./index.less"

const CSS_CLASS = "clear-history-modal";

interface Props {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}
export default function ClearHistoryModal(props: Props) {
  const { open, onCancel, onOk } = props;
  return (
    <Modal
      open={open}
      className={CSS_CLASS}
      centered
      width={320}
      closeIcon={false}
      maskClosable={false}
      okText="删除"
      onCancel={onCancel}
      onOk={onOk}
    >
      <p >提示</p>
      <p >您确定要清除所有对话吗？此操作无法撤销</p>
    </Modal>
  );
}
